export const ENCRYPTION_KEY = `${process.env.REACT_APP_STATE_ENCRYPTION_KEY}`;
export const DEBUG = `${process.env.REACT_APP_DEBUG}` === "1";
export const FRESHNESS_DELAY_IN_SECS = 60;
export const MAINTENANCE_MODE = `${process.env.MAINTENANCE_MODE}` === "1";

export const MATOMO_ENABLED = `${process.env.REACT_APP_MATOMO_ENABLED}` === "1";
export const MATOMO_SITE_ID = process.env.REACT_APP_MATOMO_SITE_ID;
export const MATOMO_DOMAIN = process.env.REACT_APP_MATOMO_DOMAIN;
